import React, { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import { Card, Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import Routes from "router/Routes";
import DeleteButton from "components/Buttons/DeleteButton";
import Title from "components/Text/Title";
import TextItem from "components/Text/TextItem";
import BackToMain from "components/Buttons/BackToMain";
import API from "apis/API";
import moment from "moment"
import Button from "@material-ui/core/Button";
import Dropdown from 'components/Form/PlainInputs/Dropdown';
import FillButton from 'components/Buttons/FillButton';
import FormInput from 'components/Form/FormInput';
import { useToasts } from 'react-toast-notifications';

//import { LineChart, Line, XAxis, YAxis, CartesianGrid } from 'recharts';

const useStyles = makeStyles((theme) => ({
    container: {
        marginBottom: theme.spacing(5)
    },
    title: {
        fontFamily: 'roboto',
        marginBottom: theme.spacing(2),
        color: theme.palette.color,
        fontSize: '0.9em',
        alignItems: 'center',
        fontWeight: '700',
    },
    facultyfiled: {
        margin: theme.spacing(1, 0),
    },
    yLabel: {
        fontFamily: 'roboto',
        color: theme.palette.color,
        fontSize: '1em',
        transform: 'rotate(-90deg) translate(-200px, -70px)',
        position: 'absolute',
    },
    xLabel: {
        fontFamily: 'roboto',
        color: theme.palette.color,
        fontSize: '1em',
        textAlign: 'center',
        width: '100%'
    },
    chart: {
        paddingLeft: '50px',
        paddingTop: '30px'
    },
    langCell: {
        marginTop: '20px',
    },
    langLabel: {
        marginBottom: '10px',
        fontFamily: 'roboto',
        color: theme.palette.color,
        fontSize: '0.9em',
        alignItems: 'center',
        fontWeight: '700',
    },
}));

const nullProfile = {
    "first_name": "",
    "last_name": "",
    "email": "",
    "group_assigments": []
}

const academicYearLabels = {
    '1': 'rok I',
    '2': 'rok II',
    '3': 'rok III',
    '4': 'rok IV',
    '5': 'rok V',
};

const StudentProfile = props => {
    const { addToast } = useToasts();
    const { id } = useParams();
    const { history } = props;
    const classes = useStyles();
    const [profile, setProfile] = useState(nullProfile);
    const [reloadStudent, setReloadStudent] = useState(false);
    const [studentLang, setStudentLang] = useState(null);
    const [showTelemetry, setShowTelemetry] = useState(false);
    const [refreshingGroupAssignments, setRefreshingGroupAssignments] = useState(false);
    const chartContainerRef = useRef();
    const [gridWidth, setGridWidth] = useState(false);
    const breadcrumbList = [
        {
            type: 'route',
            route: Routes.Students.List,
            label: 'Lista studentów',
        },
        {
            type: 'text',
            label: `${profile?.first_name} ${profile?.last_name}`,
        }
    ]

    useEffect(() => {
        API.students.show(id).then(response => {
            setStudentLang(response.data.lang)
            setProfile(response.data)
        }).catch(() => setProfile(null));
        // setProfile({
        //     index: 123456,
        //     first_name: 'John',
        //     last_name: 'Doe',
        //     email: 'admin@gmail.com'
        // })
    }, [id, reloadStudent]);

    useEffect(() => {
        if (chartContainerRef.current)
        {
            setGridWidth(chartContainerRef.current.offsetWidth)
        }
    }, []);


    // if (!profile) {
    //     return (
    //         <>
    //             <Grid container justifyContent="space-between">
    //                 <Breadcrumb list={breadcrumbList} />
    //                 <OutlineButton title={`Wróć do listy studentów`} onClick={() => history.push(Routes.Students.List)} />
    //             </Grid>
    //             {profile === null && <CircularProgress />}
    //         </>
    //     );
    // }

    const groupAssigments = profile?.group_assigments || [];

    const handleDelete = () => {
        // API.Students.delete(id).then(response => setTimeout(function () { history.push(Routes.Students.List); }, 500));
    }

    //const data = [{name: '11-12-2022', uv: 400, pv: 2400}, {name: '12-12-2022', uv: 425, pv: 2800}, {name: '15-12-2022', uv: 450, pv: 3400}, {name: '18-12-2022', uv: 500, pv: 3700}];

    const langsOptions = [
        {
            title: 'Nie ustawiony',
            id: null
        },
        {
            title: 'English',
            id: 'en'
        },
        {
            title: 'Polski',
            id: 'pl',
        },
    ]

    const handleLangChange = e => {
        setStudentLang(e.target.value)
        API.students.setLang(profile.id, e.target.value) /*.then(response => {
            //
        }).catch((e) => {
            //
        });*/
    }

    const [newPassword, setNewPassword] = useState('');
    const [newPasswordError, setNewPasswordError] = useState('');

    const handleNewPasswordChange = e => {
        const target = e.target;
        const name = target.name;
        const value = target.value;
        setNewPassword(value)
        if (newPasswordError?.trim?.()?.length)
        {
            setNewPasswordError('')
        }
    };

    const handleSavePassword = () => {
        if (newPassword?.trim?.()?.length < 6)
        {
            setNewPasswordError('Min 6 znaków')
        }
        API.students.setAppPassword(profile.id, newPassword.trim()).then(response => {
            setReloadStudent(!reloadStudent)
            addToast('Hasło zmienione', { appearance: 'success', autoDismissTimeout: 3000, autoDismiss: true });
        }) //.catch((e) => {});
    }

    const handleDeletePassword = () => {
        API.students.deleteAppPassword(profile.id).then(response => {
            setReloadStudent(!reloadStudent)
            addToast('Hasło jest resetowane', { appearance: 'success', autoDismissTimeout: 3000, autoDismiss: true });
        }) //.catch((e) => {});
    }

    const onRefreshGroupAssignmentsError = (errorMessage = null) => {
        addToast(errorMessage || 'Nie można odświeżyć kierunków studiów', { appearance: 'error', autoDismissTimeout: 3000, autoDismiss: true });
    }

    const refreshGroupAssignments = () => {
        if (!refreshingGroupAssignments)
        {
            setRefreshingGroupAssignments(true)
            API.students.refreshStudentGroups(profile.id).then(response => {
                setRefreshingGroupAssignments(false);
                setReloadStudent(!reloadStudent);
                if (response?.data?.status)
                {
                    addToast('Kierunki studiów zostały odświeżone', { appearance: 'success', autoDismissTimeout: 3000, autoDismiss: true });                
                } else {
                    onRefreshGroupAssignmentsError(response?.data?.error_code == 401 ? 'Spróbuj ponownie za 5 minut' : null);
                }
            }).catch((e) => {
                setRefreshingGroupAssignments(false);
                onRefreshGroupAssignmentsError();
            });
        }
    }

    return (
        <>
            <Grid>
                <BackToMain breadcrumbList={breadcrumbList} title={`Wróć do listy studentów`} onClick={() => history.push(Routes.Students.List)} />

                <Grid container spacing={3}>
                    <Grid item md={9}>
                        <Grid container direction="column" spacing={3}>
                            <Grid item>
                                <Card>
                                    <Grid className={classes.container}>
                                        <Title value="Dane studenta" />
                                        <TextItem subtitle="Numer albumu" md={4} value={profile?.id} />
                                        <TextItem subtitle="Imię i nazwisko" md={4} value={`${profile?.first_name} ${profile?.last_name}`} />
                                        <TextItem subtitle="E-mail" md={4} value={profile?.email} />

                                        <TextItem subtitle="Hasło Aplikacji" md={4} value={profile?.app_password ? <FillButton
                                                style={{marginRight: 0, marginTop: -4}}
                                                title={'Zresetuj hasło aplikacji'}
                                                onClick={handleDeletePassword}
                                                //saving={progressStatus}
                                            /> : "Nie ma"} />

                                        {!!(profile?.orig_password) && <>
                                            <FormInput
                                                title={'Nowe hasło aplikacji'}
                                                name={'password'}
                                                type="password"
                                                value={newPassword}
                                                onChange={handleNewPasswordChange}
                                                error={newPasswordError}
                                                //translatable
                                            />

                                            <br/>
                                            <Grid container justifyContent="flex-end">
                                                <FillButton
                                                    style={{marginRight: 0}}
                                                    title={'Ustaw nowe hasło aplikacji'}
                                                    onClick={handleSavePassword}
                                                    //saving={progressStatus}
                                                />
                                            </Grid>
                                        </>}
                                    </Grid>

                                    <Grid className={classes.container}>
                                        <Title value="Kierunki studiów" />
                                        <Grid className={classes.facultyfiled}>
                                            {groupAssigments.map((groupAssigment, index) => (
                                                <Grid key={index} className={classes.container}>
                                                    <Grid container justifyContent="flex-end">
                                                        <Grid item xs={1}>{index + 1}.</Grid>
                                                        <Grid item xs={11}>
                                                            <TextItem subtitle="Kierunek" md={3} value={`${groupAssigment.programe}`} />
                                                        </Grid>
                                                    </Grid>
                                                    <Grid container justifyContent="flex-end">
                                                        <Grid item xs={11}>
                                                            <TextItem subtitle="Grupa studencka" md={3} value={`ID ${groupAssigment.slug}`} />
                                                        </Grid>
                                                    </Grid>
                                                    <Grid container justifyContent="flex-end">
                                                        <Grid item xs={11}>
                                                            <TextItem subtitle="Rodzaj studiów" md={3} value={`${groupAssigment.genre}`} />
                                                        </Grid>
                                                    </Grid>
                                                    <Grid container justifyContent="flex-end">
                                                        <Grid item xs={11}>
                                                            <TextItem subtitle="Tryb studiów" md={3} value={`${groupAssigment.mode}`} />
                                                        </Grid>
                                                    </Grid>
                                                    <Grid container justifyContent="flex-end">
                                                        <Grid item xs={11}>
                                                            <TextItem subtitle="Rok" md={3} value={`${academicYearLabels[groupAssigment.year]}`} />
                                                        </Grid>
                                                    </Grid>
                                                    <Grid container justifyContent="flex-end">
                                                        <Grid item xs={11}>
                                                            <TextItem subtitle="Rok akademicki" md={3} value={`${groupAssigment.academic_year}`} />
                                                        </Grid>
                                                    </Grid>

                                                </Grid>
                                            ))}
                                        </Grid>
                                    </Grid>

                                    <Grid className={classes.container}>
                                        <FillButton
                                            style={{marginRight: 0}}
                                            title={'Odśwież kierunki studiów'}
                                            onClick={refreshGroupAssignments}
                                            saving={refreshingGroupAssignments}
                                        />
                                    </Grid>

                                    {/*<Grid className={classes.container}>
                                        <Title value="Telemetry" />
                                        {!showTelemetry && <Button
                                                variant="contained"
                                                color="primary"
                                                onClick={() => setShowTelemetry(true)}
                                                className={classes.submit}
                                            >
                                                Display
                                            </Button>}

                                        {showTelemetry && <Grid className={classes.facultyfiled}>
                                            {profile?.baggage?.telemetry?.map((telemetry, index) => (
                                                <Grid key={index} className={classes.container}>
                                                    <Grid container justifyContent="flex-end">
                                                        <Grid item xs={1}>{index + 1}.</Grid>
                                                        <Grid item xs={11}>
                                                            <TextItem subtitle="From" md={3} value={`${telemetry[0]}`} />
                                                        </Grid>
                                                    </Grid>
                                                    <Grid container justifyContent="flex-end">
                                                        <Grid item xs={11}>
                                                            <TextItem subtitle="To" md={3} value={`${telemetry[1]}`} />
                                                        </Grid>
                                                    </Grid>
                                                    <Grid container justifyContent="flex-end">
                                                        <Grid item xs={11}>
                                                            <TextItem subtitle="Duration" md={3} value={`${telemetry[2]} ms`} />
                                                        </Grid>
                                                    </Grid>
                                                    <Grid container justifyContent="flex-end">
                                                        <Grid item xs={11}>
                                                            <TextItem subtitle="Time" md={3} value={`${moment(telemetry[3]).format('YYYY-MM-DD H:MM:SS')}`} />
                                                        </Grid>
                                                    </Grid>

                                                </Grid>
                                            ))}
                                        </Grid>}
                                    </Grid>*/}
                                </Card>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item md={3}>
                        <Card>
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <DeleteButton
                                        title="Czy na pewno chcesz usunąć profil studenta z aplikacji?"
                                        handleDelete={handleDelete} />
                                </Grid>
                            </Grid>
                        </Card>

                        <Card className={classes.langCell}>
                            <p className={classes.langLabel}>Język aplikacji</p>
                            <Dropdown
                                name={'language'}
                                value={studentLang}
                                options={langsOptions}
                                onChange={handleLangChange}
                            />                            
                        </Card>
                    </Grid>
                </Grid>


                {/*<Grid container spacing={3}>
                    <Grid item md={9}>
                        <Grid container direction="column" spacing={3}>
                            <Grid item>
                                <Card ref={chartContainerRef} className={classes.chart}>
                                    <Title value="średnia długość trwania sesji"/>

                                    <div className={classes.yLabel}>Czas trwania [s]</div>                                    

                                    <LineChart width={gridWidth - 90} height={500} data={data}>
                                        <Line type="monotone" dataKey="uv" stroke="#2963a0" strokeWidth={4} />                                        
                                        <XAxis dataKey="name"/>                                  
                                        <YAxis/>      
                                        <CartesianGrid stroke="#ccc" />
                                    </LineChart>

                                    <div className={classes.xLabel}>Data</div>

                                </Card>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>*/}

            </Grid>
        </>
    );
};

export default StudentProfile;
